<template>
  <v-dialog v-if="errors.length" v-model="show" width="650px">
    <v-card>
      <v-card-title style="justify-content: center">{{ $t('subOrder.labelGenerationError') }}</v-card-title>
      <v-card-text>
        <v-list-item v-for="(error, key) in errors" :key="key">
          {{ error }}
        </v-list-item>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-btn block color="secondary" tile @click="$emit('close')">{{ $t('subOrder.return') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'LabelGenerationError',
    props: {
      errors: {
        type: Array,
      },
      value: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
  }
</script>
<style scoped>
  .w-45 {
    width: 45%;
  }
</style>
